import React from "react"

export const SectionDetail = props => {
  return <div className='my-2 md:text-md lg:text-lg text-gray-700'>{props.children}</div>
}
